import { render, staticRenderFns } from "./drawerDay.vue?vue&type=template&id=477de5e4&"
import script from "./drawerDay.vue?vue&type=script&lang=js&"
export * from "./drawerDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports